import { Card, CardStatus } from "@wingspanhq/wingspan-api-sdk";

export const selectorWalletCards = (cards: Card[]): Card[] =>
  cards.filter(card => card.status !== CardStatus.CANCELLED);
